import React from 'react';
import 'whatwg-fetch';
import Select from 'react-select';
import withAuth from 'src/hoc/withAuth';

const apiEmployeeShow = '/api/employee/';

const oriState = {
  dataEmployee: undefined,
  title: null,
  text: null,
  employeeSelectedId: -1,
};

class ModalReturnEmployee extends React.Component {
  constructor(props) {
    super(props);
    this.state = oriState;

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputSelectChange = this.handleInputSelectChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.reset = this.reset.bind(this);
    this.close = this.close.bind(this);
    this.checkFormValid = this.checkFormValid.bind(this);
  }

  reset() {
    this.state = oriState;
    this.setState(oriState);
    this.componentDidMount();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }
  handleInputSelectChange(val) {
    console.log(val);

    const value = this.props.multi ? val : val ? val['id'] : undefined;

    this.setState({
      employeeSelectedId: value,
    });
  }

  componentDidMount() {
    let queryURL = apiEmployeeShow;
    let graphQL = '{ employees{ id, firstname, lastname } }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['employees']) {
            this.setState({
              dataEmployee: data['data']['employees'],
            });
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch list employees entity: \n' + error);
        }.bind(this)
      );
  }

  checkFormValid() {
    return !this.props.employeeRequired || this.state.employeeSelectedId !== -1;
  }

  render() {
    if (this.props.isOpen === false) return null;

    const { dataEmployee } = this.state;

    return (
      <div className='modal myModal'>
        <div className='modal-dialog modal-md'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h4 className='modal-title'>{this.props.modalText.title}</h4>
              <button onClick={this.close} type='button' className='close' data-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <form>
              <div className='modal-body'>
                <p>{this.props.modalText.message}</p>
                <div className='form-group'>
                  <label>Employé</label>
                  <Select
                    multi={this.props.multi}
                    className='inputModalSelect'
                    name='employeeSelectedId'
                    value={this.state.employeeSelectedId}
                    labelKey={'firstname'}
                    valueKey={'id'}
                    options={dataEmployee}
                    onChange={this.handleInputSelectChange}
                    noResultsText={'Aucun résultat'}
                    placeholder={'Nom'}
                    clearValueText={'Supprimer'}
                  />
                </div>
              </div>
              <div className='modal-actions'>
                <button onClick={this.close} type='button' className='btn-link modal-action' data-dismiss='modal'>
                  Annuler
                </button>
                <button
                  onClick={this.handleSubmit}
                  type='button'
                  className='btn-link modal-action'
                  data-dismiss='modal'
                >
                  <strong>Valider</strong>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

  handleSubmit() {
    if (this.props.onPostResult) {
      if (this.checkFormValid()) {
        this.props.onPostResult(this.state.employeeSelectedId);
        this.close();
      } else {
        this.props.openToast(false, 'Certains champs obligatoires sont vides');
      }
    }
  }

  close() {
    this.reset();
    if (this.props.onClose) {
      this.props.onClose();
    }
  }
}

export default withAuth(ModalReturnEmployee);
